import React from "react";
import { PulseLoader } from "./pulse_loader";

/**
 * Centered PulseLoader for consistent Suspense/loading fallback UI.
 * Use as fallback={ <CenteredPulseLoader /> } to keep loading-state presentation consistent.
 */
export function CenteredPulseLoader() {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <PulseLoader />
    </div>
  );
}
